import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "my-3" }
const _hoisted_2 = { class: "d-flex d-md-flex flex-column-reverse flex-md-row align-items-start" }
const _hoisted_3 = { class: "col-md-9 col-lg-10 px-0 ps-md-4 pe-md-3" }

import {
	ref,
	Ref,
	computed,
	ComputedRef,
	Component,
	watch
} from "vue";
//import store from "@/vue/planning/store/store";
import PrestationPopup from "@/vue/planning/components/result/prestationPopup.vue";
import PrestationPictureDesktop from "@/vue/planning/components/result/prestation/pictureDesktop.vue";
import BorderHorizontal from "@/vue/common/borderHorizontal.vue";
import DetailsTop from "@/vue/planning/components/result/prestation/detailsTop.vue";
import PrestVariantDefault from "@/vue/planning/components/result/prestation/PrestVariantDefault.vue";
import PrestVariantPierreVacance from "@/vue/planning/components/result/prestation/PrestVariantPierreVacance.vue";
import PopupBase from "@/vue/common/popupBase.vue";
import { isPierreVacance } from "@/vue/planning/logic/pv";
import { sortVariantsBySkipassAndPrice } from "@/vue/planning/logic/updateVariants";

import { PrestationData, Variant } from "@/types";

import { useStore } from "vuex"
interface Props {
	prestation: PrestationData;
	activePrestation?: PrestationData;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'prestation',
  props: {
    prestation: { default: () => ({} as PrestationData) },
    activePrestation: { default: () => ({} as PrestationData) }
  },
  setup(__props: any) {

const store = useStore();

const props = __props;

// refs
const isPopupOpen: Ref<boolean> = ref(false);

// data state
const data = ref({
	popUpWasOpened: false
});

// computed

const image: ComputedRef<string> = computed(() => {
	const images = props.prestation?.picturesAccomodation || [];
	if (images.length === 0) return "";

	const img = images[0];
	return (
		img["imgSmall"] ||
		img["imgMedium"] ||
		img["imgLarge"] ||
		img["imgXL"] ||
		img["img"] ||
		""
	);
});
const isDisplayPlaceholders: ComputedRef<boolean> = computed(() => {
	return Object.keys(props.prestation).length === 0;
});
const isSelected: ComputedRef<boolean> = computed(() => {
	if (!props.prestation || !props.prestation.variants) return false;
	for (const variant of props.prestation.variants) {
		if (store.state.selectedPrestIds[variant.id]) return true;
	}
	return false;
});

const variants: ComputedRef<Variant[]> = computed(() => {
	return sortVariantsBySkipassAndPrice(props.prestation.variants || []);
});

// methods
const getPrestComponent = (variant: any): Component => {
	if (isPierreVacance(variant)) {
		return PrestVariantPierreVacance;
	}
	return PrestVariantDefault;
};
const handleClosePopup = () => {
	isPopupOpen.value = false;
};

const handleOpenPopup = () => {
	isPopupOpen.value = true;
};

const handleSelect = (id: string) => {
	console.log('[prestation.vue] handleSelect called with id:', id);
	// Removed skipass duration check to let Vuex handle validation
	const obj: { [key: string]: number } = {};
	obj[id] = 1;
	store.dispatch("setSelectedPrestIds", obj);
};

const handleClear = (id: string) => {
	const obj: { [key: string]: number } = {};
	obj[id] = 0;
	store.dispatch("setSelectedPrestIds", obj);
};

const handleDropdownSelect = (something: any) => {
	const { newSelected, id } = something;
	const obj: { [key: string]: number } = {};
	obj[id] = newSelected;
	store.dispatch("setSelectedPrestIds", obj);
};

const handleDropdownClick = (obj: any) => {
	if (store.state.selectDropdownOpen_prestId === obj.id) {
		obj["id"] = "";
	}
	store.dispatch("setSelectDropdownOpen_prestId", obj);
};

const getPrestation=(isActivePrestation?:boolean): PrestationData => {
	if(!isActivePrestation) return props.prestation
	return props.activePrestation
}

const handleactivePrestation=():void=> {
	if(store.state.activePrestations) {
		const isActivePrestation: boolean = store.state.activePrestations[0] === props.prestation.prestationId

		if(isActivePrestation) {
			getPrestation(isActivePrestation)
			data.value.popUpWasOpened = true;
			// TODO: Refactor the components load/update sequence to eliminate the need for this timeout.
			setTimeout(() => {
					handleOpenPopup()
			}, 1500)
		}
	}
}

watch(
	() => store.state.prestationsFromCatalog,
	() => {
		if (!data.value.popUpWasOpened && store.state.prestationsFromCatalog.length > 0) {
			handleactivePrestation();
		}
	}
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["bg-white cursor-pointer prestation-wrapper", isSelected.value ? 'selected outline-hover' : '']),
      onClick: _withModifiers(handleOpenPopup, ["stop"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(PrestationPictureDesktop, {
          src: image.value,
          isDisplayPlaceholders: isDisplayPlaceholders.value,
          selected: isSelected.value,
          onPlusInfosClick: handleOpenPopup
        }, null, 8, ["src", "isDisplayPlaceholders", "selected"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(DetailsTop, {
            onPlusInfosClick: handleOpenPopup,
            prestation: props.prestation,
            image: image.value,
            isDisplayPlaceholders: isDisplayPlaceholders.value
          }, null, 8, ["prestation", "image", "isDisplayPlaceholders"]),
          (isDisplayPlaceholders.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(BorderHorizontal),
                _createVNode(PrestVariantDefault, {
                  variant: null,
                  isDisplayPlaceholders: isDisplayPlaceholders.value
                }, null, 8, ["isDisplayPlaceholders"])
              ], 64))
            : (!_unref(store).state.activePrestations)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(variants.value, (variant, variant_i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `${variant_i}-${variant.id}`
                  }, [
                    _createVNode(BorderHorizontal),
                    (_openBlock(), _createBlock(_resolveDynamicComponent(getPrestComponent(variant)), {
                      variant: variant,
                      onSelect: handleSelect,
                      onDropdownClick: handleDropdownClick,
                      onClear: handleClear,
                      onDropdownSelect: handleDropdownSelect
                    }, null, 40, ["variant"]))
                  ]))
                }), 128))
              : _createCommentVNode("", true)
        ])
      ])
    ], 2),
    _createVNode(PopupBase, {
      open: isPopupOpen.value,
      onClosePopup: handleClosePopup,
      "overlay-color": 'rgba(13, 20, 27, 0.95)',
      "overlay-max-opacity": 1
    }, {
      default: _withCtx(() => [
        _createVNode(PrestationPopup, {
          open: isPopupOpen.value,
          prestation: getPrestation(),
          onClosePopup: handleClosePopup,
          onSelect: _cache[0] || (_cache[0] = 
					(id) => {
						handleSelect(id);
						handleClosePopup();
					}
				),
          onDropdownClick: _cache[1] || (_cache[1] = (obj) => handleDropdownClick(obj)),
          onClear: _cache[2] || (_cache[2] = (id) => handleClear(id)),
          onDropdownSelect: _cache[3] || (_cache[3] = 
					({ newSelected, id }) => handleDropdownSelect({ newSelected, id })
				)
        }, null, 8, ["open", "prestation"])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})